import logo from '/@/assets/img/general/logo.png';

export default {
    logo
};